import { useMutation } from '@tanstack/react-query';

import {
  IOrderResponseDto,
  ISubscriptionRenewalDTO,
  ISubscriptionRenewalParamsDTO,
  subscriptionRenewal,
} from '@/shared/api/subscriptions';

export function useRenewSubscription() {
  const renewSubscriptionMutation = useMutation({
    mutationFn: ({
      subscriptionData,
      params,
    }: {
      subscriptionData: ISubscriptionRenewalDTO;
      params: ISubscriptionRenewalParamsDTO;
    }) => {
      return subscriptionRenewal(subscriptionData, params);
    },
  });

  const renewSubscription = (
    data: {
      subscriptionData: ISubscriptionRenewalDTO;
      params: ISubscriptionRenewalParamsDTO;
    },
    onCreated?: (data: IOrderResponseDto) => void
  ) => {
    return renewSubscriptionMutation.mutateAsync(data, {
      onSuccess: onCreated,
    });
  };

  return {
    renewSubscription,
    ...renewSubscriptionMutation,
  };
}
